<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="max-2xl">
                <div class="py-5 text-2xl font-bold">
                    Autenticazione Ninja
                </div>
                <div v-if="!loading && message.length" :class="[is_authenticated ? 'bg-next-bri' : 'bg-next-orange']"
                     class="text-white p-3 mb-3 flex justify-between items-center">
                    {{ message }}
                </div>
                <NextButton v-if="!loading && !is_authenticated" class="py-2 px-3 mr-3" @click="handleUnauthorized">Autentica
                </NextButton>

                <NextButton v-if="!loading" class="py-2 px-3 mr-3" @click="syncContacts">Sincronizza contatti
                </NextButton>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapGetters} from 'vuex';
import NextButton from "@/components/NextButton.vue";
import supportManager from "@/api/Support";
import Alert from "@/components/Alert.vue";
import Loading from "@/components/Loading.vue";

@Options({
    name: 'LoginNinja',
    components: {
        Loading,
        Alert,
        NextButton
    },
    computed: {
        ...mapGetters([
            'me',
        ])
    }
})
export default class LoginNinja extends Vue {
    message = ''
    loading = false;
    is_authenticated = false;

    test() {
        this.loading = true
        /* sulla creazione del componente faccio una chiamata al BE che fa le seguenti cose tramite una middleware
        - cerco se il record di configurazione è presente sul database, se fallisce 404
        - controllo che il token esista, se fallisce 404
        - controllo che il token non sia scaduto, se scaduto provo a rinnovarlo, se fallisce 503
        - se tutto passa fin qui il token dovrebbe essere valido, allora provo a fare una chiamata api sugli utenti, se fallisce 402
        - se tutto è andato bene allore ritorno successo
        * */
        supportManager.checkNinjaAuth().then((res) => {
            this.message = "Il token di autenticazione è valido"
            this.is_authenticated = true
        }).catch(res => {
            this.is_authenticated = false
            if (res.response.status == 404) {
                this.message = "Il token di autenticazione non è presente, necessario autenticarsi"
            } else if (res.response.status == 503) {
                this.message = "Il token di autenticazione è scaduto e il rinnovo è fallito"
            } else if (res.response.status == 402) {
                this.message = "Il token di autenticazione è presente, ma la chiamata di test è fallita"
            }
        }).finally(() => {
            this.loading = false
        })
    }

    syncContacts() {
        this.loading = true
        supportManager.syncContacts().then((res) => {
           console.log(res.data)
        }).finally(() => {
            this.loading = false
        })

    }

    created() {
        this.test()
    }

    handleUnauthorized() {
        window.onmessage = () => {
            this.test()
        };
        const newWindow = window.open("/auth/ninjarmm/init", 'name', 'height=600,width=450');
        if (newWindow) {
            newWindow.focus();
        }
    }
}

</script>


<style lang="scss">

</style>
